import Layout from '../../components/layoutConfig/layout';
import { useState, ChangeEvent, FormEvent, DragEvent, useEffect } from 'react';
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { setupAPIclient } from '../../services/setupAPIclient';
import LocalStorage from '../../helpers/localstorage';
import Select from "react-select";

interface User {
  id: number;
  email: string;
  name: string;
  number_phone: string;
  can_view: boolean;
}

interface CompanyData {
  company_id: number;
  name_company: string;
  region_id: number;
  region_name: string;
  unit_id: number;
  unit_name: string;
  location_id: number;
  location_name: string;
}

interface Signatory {
  user_id: number;
}

function UploadPage() {
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [previewUrl, setPreviewUrl] = useState<string | null>(null);

  const [users, setUsers] = useState<User[]>([]);
  const [companies, setCompanies] = useState<CompanyData[]>([]);
  const [signatories, setSignatories] = useState<Signatory[]>([]);


  const [selectedCompany, setSelectedCompany] = useState<number | null>(null);
  const [selectedRegion, setSelectedRegion] = useState<number | null>(null);
  const [selectedUnit, setSelectedUnit] = useState<number | null>(null);
  const [selectedLocation, setSelectedLocation] = useState<number | null>(null);

  const [sms, setSms] = useState(false);
  const [whats, setWhats] = useState(false);
  const [emailNoti, setEmailNoti] = useState(true);
  const [reminderDays, setReminderDays] = useState(7);
  const [dueDate, setDueDate] = useState("");

  const [contractName, setContractName] = useState("");
  const [message, setMessage] = useState("");

  const localStorage = new LocalStorage();
  const token = String(localStorage.getAuthToken());
  const ApiClient = setupAPIclient(token);



   // Buscar notificação existente
  const handleGetNotification = async () => {
    const response = await ApiClient.post("/management/get/notification");
  };


  // Upload de arquivo
  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };
  const handleDrop = (e: DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      setSelectedFile(file);
      setPreviewUrl(URL.createObjectURL(file));
    }
  };
  const handleDragOver = (e: DragEvent<HTMLDivElement>) => e.preventDefault();

  // Buscar usuários
  const handleGetUsers = async () => {
    try {
      const response = await ApiClient.post("/management/get/users");
      if (response.data.success) setUsers(response.data.success);
    } catch (err) {
      console.error("Erro ao buscar usuários:", err);
      toast.error("Erro ao carregar usuários");
    }
  };

  // Buscar empresas
  const handleGetCompanies = async () => {
    try {
      const response = await ApiClient.post("/management/get/company");
      if (response.data.success) setCompanies(response.data.success);
    } catch (err) {
      console.error("Erro ao buscar empresas:", err);
      toast.error("Erro ao carregar empresas");
    }
  };

  // Atualiza região, unidade e local ao selecionar empresa
  const handleCompanyChange = (companyId: number) => {
    setSelectedCompany(companyId);
    const company = companies.find(c => c.company_id === companyId);
    if (company) {
      setSelectedRegion(company.region_id);
      setSelectedUnit(company.unit_id);
      setSelectedLocation(company.location_id);
    } else {
      setSelectedRegion(null);
      setSelectedUnit(null);
      setSelectedLocation(null);
    }
  };

  const handleSubmitUpload = async (e: FormEvent) => {
    e.preventDefault();
    if (!selectedFile) return toast.error("Selecione um documento!");
    if (!dueDate) return toast.error("Informe a data de vencimento!");
    if (!contractName.trim()) return toast.error("Informe o nome do contrato!");
    if (!message.trim()) return toast.error("Informe a mensagem da notificação!");
    if (signatories.length === 0) return toast.error("Adicione pelo menos um usuário!");

    try {
      const dataForm = new FormData();
      dataForm.append("uploaddoc", selectedFile);
      dataForm.append("data_vencimento", dueDate);
      dataForm.append("sms", String(sms));
      dataForm.append("whatts", String(whats));
      dataForm.append("email", String(emailNoti));
      dataForm.append("message", message);
      dataForm.append("reminder_days", String(reminderDays));
      dataForm.append("name", String(contractName));


      // Signatários
      dataForm.append("user_id", JSON.stringify(signatories));

      if (selectedCompany) dataForm.append("company_id", String(selectedCompany));
      if (selectedRegion) dataForm.append("region_id", String(selectedRegion));
      if (selectedUnit) dataForm.append("unit_id", String(selectedUnit));
      if (selectedLocation) dataForm.append("location_id", String(selectedLocation));

      const response = await ApiClient.post("/management/uploaddoc", dataForm, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      if (response.data?.success) {
        toast.success("✅ Documento enviado com sucesso!");
        setSelectedFile(null);
        setPreviewUrl(null);
        setDueDate("");
        setSignatories([]);
        setSelectedCompany(null);
        setSelectedRegion(null);
        setSelectedUnit(null);
        setSelectedLocation(null);
        setSms(false);
        setWhats(false);
        setEmailNoti(true);
        setReminderDays(7);
        setContractName("");
        setMessage("");
      } else {
        const msg = response.data?.message || "Erro no envio do documento";
        toast.error(`❌ ${msg}`);
      }
    } catch (err: any) {
      console.error("Erro ao enviar:", err);
      const serverMessage = err?.response?.data?.message;
      if (serverMessage) toast.error(`❌ ${serverMessage}`);
      else toast.error("❌ Erro no envio do documento");
    }
  };

  useEffect(() => {
    handleGetUsers();
    handleGetCompanies();
  }, []);

  // Configuração react-select para usuários
  const userOptions = users.map(u => ({ value: u.id, label: `${u.name} (${u.email})` }));

  return (
    <Layout>
      <div className="row py-4">
        <form onSubmit={handleSubmitUpload}>
          <div className="row g-4">

            {/* Sidebar esquerda */}
            <div className="col-md-4 d-flex">
              <div className="card shadow-sm border-0 rounded-3 w-100 h-100">
                <div className="card-body">

                  {/* Nome do contrato */}
                  <div className="card p-3 shadow-lg border-0 rounded-4 mb-4">
                    <h5 className="fw-bold mb-2 text-dark">
                      <i className="bi bi-file-text me-2" style={{color:"#5dade2"}}></i>
                      <span style={{color:"#5dade2"}}> Nome do contrato</span>
                    </h5>
                    <input
                      type="text"
                      className="form-control mb-3"
                      placeholder="Digite o nome do contrato"
                      value={contractName}
                      onChange={e => setContractName(e.target.value)}
                    />
                  </div>

                  {/* Usuários */}
                  <h5 className="fw-bold mb-2" style={{color:"#5dade2"}}>
                    <i className="bi bi-people me-2"></i> Integrantes
                  </h5>
                  <Select
                    options={userOptions}
                    isMulti
                    placeholder="Selecione um ou mais usuários..."
                    value={signatories.map(s => userOptions.find(u => u.value === s.user_id))}
                    onChange={(selected) => {
                      const selectedArray = Array.isArray(selected) ? selected : [selected];
                      setSignatories(selectedArray.map(u => ({ user_id: u.value })));
                    }}
                    className="mb-3"
                  />

                  {/* Empresa / Região / Unidade / Local */}
                  <h5 className="fw-bold mb-2" style={{color:"#5dade2"}}>
                    <i className="bi bi-building me-2"></i> Empresa / Região / Unidade / Local
                  </h5>
                  <select
                    className="form-select mb-2"
                    value={selectedCompany ?? ""}
                    onChange={e => handleCompanyChange(Number(e.target.value))}
                  >
                    <option value="">-- Selecione a empresa --</option>
                    {companies.map(c => (
                      <option key={c.company_id} value={c.company_id}>
                        {c.name_company}
                      </option>
                    ))}
                  </select>

                  <select
                    className="form-select mb-2"
                    value={selectedRegion ?? ""}
                    onChange={e => setSelectedRegion(Number(e.target.value))}
                  >
                    <option value="">-- Selecione a região (opcional) --</option>
                    {companies
                      .filter(c => c.company_id === selectedCompany)
                      .map(c => (
                        <option key={c.region_id} value={c.region_id}>
                          {c.region_name}
                        </option>
                      ))}
                  </select>

                  <select
                    className="form-select mb-2"
                    value={selectedUnit ?? ""}
                    onChange={e => setSelectedUnit(Number(e.target.value))}
                  >
                    <option value="">-- Selecione a unidade (opcional) --</option>
                    {companies
                      .filter(c => c.company_id === selectedCompany)
                      .map(c => (
                        <option key={c.unit_id} value={c.unit_id}>
                          {c.unit_name}
                        </option>
                      ))}
                  </select>

                  <select
                    className="form-select mb-3"
                    value={selectedLocation ?? ""}
                    onChange={e => setSelectedLocation(Number(e.target.value))}
                  >
                    <option value="">-- Selecione o local (opcional) --</option>
                    {companies
                      .filter(c => c.company_id === selectedCompany)
                      .map(c => (
                        <option key={c.location_id} value={c.location_id}>
                          {c.location_name}
                        </option>
                      ))}
                  </select>

                  {/* Vencimento */}
                  <h5 className="fw-bold mb-2" style={{color:"#5dade2"}}>
                    <i className="bi bi-calendar-event me-2" style={{color:"#5dade2"}}></i> Vencimento
                  </h5>
                  <input
                    type="date"
                    className="form-control mb-4"
                    value={dueDate}
                    onChange={e => setDueDate(e.target.value)}
                  />

                  {/* Lembretes <h5 className="fw-bold mb-2" style={{color:"#5dade2"}}>
                    <i className="bi bi-bell me-2"></i> Lembretes
                  </h5><div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={sms}
                      onChange={() => setSms(!sms)}
                    />
                    <label className="form-check-label">SMS</label>
                  </div> <div className="form-check mb-3">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={emailNoti}
                      onChange={() => setEmailNoti(!emailNoti)}
                    />
                    <label className="form-check-label">Email</label>
                  </div><h6 className="fw-bold text-secondary">Mensagem da notificação</h6>
                  <textarea
                    className="form-control mb-4"
                    placeholder="Digite a mensagem da notificação"
                    rows={3}
                    value={message}
                    onChange={e => setMessage(e.target.value)}
                  /> */}

                  {/* Reminder days */}
                  <h6 className="fw-bold text-secondary mb-2">Lembrete (dias)</h6>
                  <input
                    type="number"
                    className="form-control mb-4"
                    min={1}
                    value={reminderDays}
                    onChange={e => setReminderDays(Number(e.target.value))}
                  />

                  <button type="submit" className="btn w-100 py-2" style={{backgroundColor:"#e74c3c", color:"#fff"}}>
                    <i className="bi bi-upload me-2" style={{color:"#fff"}}></i> Enviar documento
                  </button>

                </div>
              </div>
            </div>

            {/* Área de upload */}
            <div className="col-md-8 d-flex">
              <div
                className="card shadow-sm border-0 rounded-3 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{ minHeight: "600px" }}
                onDrop={handleDrop}
                onDragOver={handleDragOver}
              >
                {!previewUrl ? (
                  <div className="text-center text-muted">
                    <i className="bi bi-file-earmark-arrow-up display-1 text-secondary mb-3"></i>
                    <p className="fw-bold">Arraste o documento aqui</p>
                    <p>ou clique no botão abaixo</p>
                    <label className="btn" style={{backgroundColor:"#e74c3c", color:"#fff", marginTop:"0.5rem"}}>
                      <i className="bi bi-folder2-open me-2" style={{color:"#fff"}}></i> Selecionar arquivo
                      <input type="file" hidden onChange={handleFileChange} />
                    </label>
                  </div>
                ) : (
                  <iframe
                    src={previewUrl}
                    title="Preview do contrato"
                    style={{
                      width: "100%",
                      height: "100%",
                      border: "none",
                      borderRadius: "8px"
                    }}
                  />
                )}
              </div>
            </div>

          </div>
        </form>
      </div>
    </Layout>
  );
}

export default UploadPage;
